import { CompanySettingWorkingDay } from "domain-entities";
import { WorkingDaysKey } from "../types/WorkingDaysKey";
import { getWorkingDaysString } from "./getWorkingDaysString";

export function getWorkingDays(
	workingDaysKey: WorkingDaysKey
): CompanySettingWorkingDay[] {
	const workingDaysString = getWorkingDaysString(workingDaysKey);

	return workingDaysString.split("").map((enabled) => ({
		enabled: !!Number(enabled),
	}));
}
